export const VALIDATION_ERROR_MESSAGES = {
  APPLICANT_SAME_AS_TRACKING:
    'The applicant number cannot be the same as the tracking number.',
  PROSPECT_SAME_AS_TRACKING:
    'The prospect number cannot be the same as the tracking number.',
  RESIDENT_SAME_AS_TRACKING:
    'The resident number cannot be the same as the tracking number.',
  SAME_AS_TRACKING: 'The number cannot be the same as the tracking number.',
};

export const RECORDING_TYPES = {
  APPLICANT: 'applicant',
  PROSPECT: 'prospect',
  RESIDENT: 'resident',
};

export const GREETING_MODAL_TITLES = {
  [RECORDING_TYPES.APPLICANT]: 'Applicant Greeting Audio',
  [RECORDING_TYPES.PROSPECT]: 'Prospect Greeting Audio',
  [RECORDING_TYPES.RESIDENT]: 'Resident Greeting Audio',
};

export const GREETING_URL_PAYLOAD_KEY = {
  [RECORDING_TYPES.APPLICANT]: 'greeting_url_applicant',
  [RECORDING_TYPES.PROSPECT]: 'greeting_url',
  [RECORDING_TYPES.RESIDENT]: 'greeting_url_resident',
};
